import { TranslationObject } from '../i18n/translation';

const namespace = 'practicetype.uha';
const translations: TranslationObject = {
  numPlaces: {
    id: `${namespace}.numPlaces`,
    nb: 'Steder som innfrir kravet',
    en: 'Places that meet the requirement',
  },
  practicePlacesWithAgreement: {
    id: `${namespace}.practicePlacesWithAgreement`,
    nb: 'Praksissteder med avtale',
    en: 'Practice places with agreement',
  },
  meetsRequirement: {
    id: `${namespace}.meetsRequirement`,
    nb: 'Dekket kravet',
    en: 'Meets requirement',
  },
};

export default translations;
